<template>
  <div class="reelbuzz">
    <div class="header">
      <div class="header-menu">
        <div class="header-left">
          <img src="../assets/logo.png" alt="logo-icon">
          <p>VayaYa</p>
        </div>
        <ul class="header-right">
          <li v-for="section in sections" :key="section.id" class="menu">
            <a :href="'#' + section.id" @click="gotoMEnu(section.id)"
              :class="{ 'active': section.id === currentSection }">{{ section.title }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="reelbuzz-content">
      <div class="reelbuzz-box" id="section1">
        <div class="header-box">
          <p class="name">VayaYa</p>
          <!-- <p class="name">achieve success.</p> -->
          <p class="title">Su plataforma financiera para ayudarle a obtener apoyo financiero, simplemente solicite en línea para obtener un préstamo</p>
        </div>
      </div>
    </div>
    <div class="audit-box">
      <div class="audit">
        <div class="education-box">
          <div class="education">
            <div class="img-box">
              <img src="../assets/home-light.png" alt="computer">
              <p class="img-number">01</p>
            </div>
            <p class="education-name"> Servicios personalizados para satisfacer diversas necesidades.</p>
            <p class="education-title">Al brindar servicios financieros a medida, ya sea usted un particular o una
              empresa, podrá encontrar el apoyo más adecuado. </p>
          </div>
          <div class="education">
            <div class="img-box">
              <img src="../assets/home-computer.png" alt="computer">
              <p class="img-number">02</p>
            </div>
            <p class="education-name"> Tecnología financiera eficiente y conveniente</p>
            <p class="education-title">A través de tecnología financiera avanzada, brindamos a los clientes una
              experiencia de servicio eficiente y conveniente.</p>
          </div>
          <div class="education">
            <div class="img-box">
              <img src="../assets/home-talk.png" alt="computer">
              <p class="img-number">03</p>
            </div>
            <p class="education-name"> Equipo profesional para proteger los intereses del cliente</p>
            <p class="education-title">Contamos con un equipo experimentado de expertos financieros para brindarle un
              servicio al cliente de alta calidad y garantizar la salud financiera de cada cliente.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="choose-us-box" id="section2">
      <div class="choose-us">
        <div class="choose-us-left">
          <img src="../assets/chooseus.png" alt="chooseus">
        </div>
        <div class="choose-us-right">
          <p class="choose-us-name">¿Quiénes somos?</p>
          <p class="choose-us-title">Somos una empresa 100% mexicana dedicada a satisfacer las necesidades financieras
            de nuestros clientes a través de un servicio eficiente, personal y profesional.
            Brindamos soluciones financieras efectivas y también estamos comprometidos a ayudar a los usuarios a
            satisfacer sus necesidades financieras e impactar positivamente en su crecimiento.</p>
          <div class="choose">

            <div class="choose-box">
              <div class="choose-img-box">
                <img src="../assets/chooseimg.png" alt="choose-right" class="choose-img">
                <p class="choose-img-title">Nuestra misión</p>
              </div>
              <p class="choose-name">Satisfaga las diversas necesidades financieras de los clientes a través de
                servicios financieros innovadores y soporte personalizado.</p>
            </div>
            <div class="choose-box">
              <div class="choose-img-box">
                <img src="../assets/chooseimgs.png" alt="choose-right" class="choose-img">
                <p class="choose-img-title">Nuestra visión</p>
              </div>
              <p class="choose-name">Para convertirnos en el proveedor de servicios financieros más confiable en México
                e incluso en América Latina, esperamos construir un ecosistema sustentable.</p>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="services-box">
      <div class="services">
        <div class="services-block" id="section4"></div>
        <div class="service-title">
          Beneficios para los colaboradores
        </div>
        <div class="item-service-box">
          <div class="item-service">
            <img src="../assets/service-vodio.png" alt="service">
            <p class="item-service-title">Rápido y fácil</p>
          </div>
          <div class="item-service">
            <img src="../assets/service-money.png" alt="service">
            <p class="item-service-title">Fondos disponibles en cualquier momento</p>
          </div>
          <div class="item-service">
            <img src="../assets/service-anay.png" alt="service">
            <p class="item-service-title">Reducir el estrés financiero</p>
          </div>
          <div class="item-service">
            <img src="../assets/service-talk.png" alt="service">
            <p class="item-service-title">Mejorar la calidad de vida</p>
          </div>

        </div>
      </div>
    </div>

    <div class="contact-box">
      <div class="contact">
        <div class="contact-title" id="section5">
          Nuestras ventajas
        </div>
        <div class="contact-content">
          <div class="offer-box">
            <div class="offer-img">
              <img src="../assets/offer-left.png" alt="offer-img">
            </div>
            <div class="offer-title">
              Gestión en línea
            </div>
            <div class="offer-name">
              Proceso sin papel, los usuarios pueden solicitar préstamos en línea
            </div>
          </div>
          <div class="offer-box">
            <div class="offer-img">
              <img src="../assets/offer-middle.png" alt="offer-img">
            </div>
            <div class="offer-title">
              Seguridad de datos
            </div>
            <div class="offer-name">
              Los usuarios pueden optar por eliminar permanentemente la información de su cuenta.
            </div>
          </div>
          <div class="offer-box">
            <div class="offer-img">
              <img src="../assets/offer-right.png" alt="offer-img">
            </div>
            <div class="offer-title">
              Aprobación rápida
            </div>
            <div class="offer-name">
              La aprobación se realiza según el modelo de datos y la conclusión de la aprobación se emite en 5 minutos.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="reelbuzz-footer">
      <div class="footer-content">
        <div class="footer-company">
          <p class="company-title">Te Acreditamos</p>
          <p class="company-name">Simplifique las finanzas y ayúdelo a alcanzar la libertad financiera.</p>
        </div>
        <div class="footer-menu">
          <div class="menu-title">
            Menú
          </div>
          <div class="menu-name" @click="gotoMEnu('section1')">Inicio</div>
          <div class="menu-name" @click="gotoMEnu('section2')">Quiénes somos</div>
          <div class="menu-name" @click="gotoMEnu('section3')">Nuestros productos</div>
          <div class="menu-name" @click="gotoMEnu('section4')">Nuestros Servicios</div>
          <div class="menu-name" @click="gotoMEnu('policy')">Política de privacidad</div>
        </div>
        <div class="footer-contact">
          <div class="contact-title">
            Contáctenos
          </div>
          <div class="contact-name-box">
            <p>Correo electrónico: support@teacreditamosmx.com</p>

            <p>Horario de atención: Lunes a viernes de 10:00 a 18:30 horas</p>
            <p>Dirección: Av. Ricardo margain zozaya, 440 piso 8 int 803, Valle del campestre, San Pedro Garza García,
              Nuevo León, C.P. 66265</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      type: 1,
      sections: [
        { id: 'section1', title: 'Inicio' },
        { id: 'section2', title: 'Quiénes somos' },
        { id: 'section5', title: 'Nuestros Servicios' },
      ],
      currentSection: ''
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    gotoAPP() {
      window.open('https://apps.apple.com/mx/app/id6737598795')
    },
    scrollToSection(id) {
      this.currentSection = id;
      const targetSection = document.getElementById(id);
      c
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      this.sections.forEach(section => {
        const targetSection = document.getElementById(section.id);
        if (targetSection.offsetTop <= scrollPosition && targetSection.offsetTop + targetSection.offsetHeight > scrollPosition) {
          this.currentSection = section.id;
        }
      });
    },
    gotoMEnu(id) {
      if (id == 'policy') {
        this.$router.push({
          name: 'policy'
        })
      }
      const targetElement = document.getElementById(id);
      if (targetElement) {
        const targetPosition = targetElement.offsetTop + 50;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 500; // 滚动持续时间，单位毫秒
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) {
            startTime = currentTime;
          }
          const timeElapsed = currentTime - startTime;
          const run = ease(timeElapsed, startPosition, distance, duration);
          window.scrollTo(0, run);
          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        }

        function ease(t, b, c, d) {
          t /= d / 2;
          if (t < 1) return c / 2 * t * t + b;
          t--;
          return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animation);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.color-fff {
  color: #fff;
}

.color-000 {
  color: #000;
}

.color-595 {
  color: #595566;
}

.header {
  position: fixed;
  width: 100%;
  z-index: 999;
  background: none;
  transition: 0.5s;
  height: 100px;
  background: #fff;

  .header-menu {
    width: 1800px;
    height: 100px;
    min-width: 1800;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .header-left {
      height: 100px;
      width: 600px;
      display: flex;
      align-items: center;
      margin-right: 60px;

      img {
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }

      p {
        height: 40px;
        font-family: Scada, Scada;
        font-weight: bold;
        font-size: 18px;
        color: #6964EE;
        line-height: 38px;
      }
    }

    .header-right {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .menu {
        height: 30px;
        margin: 0 10px;
        line-height: 20px;
        font-weight: 400;
        font-size: 18px;
        text-align: center;
        color: #333333;
        cursor: pointer;
        box-sizing: border-box;

        a {
          color: #333333;
          padding: 4px 22px;
        }

        .active {
          color: #fff;
        }
      }

      .menu:last-child {
        margin-right: 0;
      }

      .active {
        font-weight: 900;
        color: #fff;
        background: #6964EE;
        transition: all 0.8s;

      }
    }
  }
}

.reelbuzz-content {
  padding-top: 100px;

  .reelbuzz-box {
    width: 100%;
    height: 800px;
    background: url(../assets/homeBg.png) center top no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    box-sizing: border-box;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .header-box {
      width: 1320px;
      height: 100%;
      margin: 0 auto;
      padding-top: 195px;
      box-sizing: border-box;
      padding-right: 500px;

      .name {
        font-weight: bold;
        font-size: 60px;
        color: #fff;
        line-height: 70px;
        margin-bottom: 32px;
      }

      .title {
        font-family: Roboto, Roboto;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 26px;
      }
    }
  }
}

.audit-box {
  width: 100%;
  height: 480px;

  .audit {
    width: 1320px;
    height: 100%;
    margin: 0 auto;
    box-sizing: border-box;

    .education-box {
      width: 100%;
      height: 460px;
      margin-top: -98px;
      margin-bottom: 140px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .education {
        width: 420px;
        height: 100%;
        background: #fff;
        box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.08);
        padding: 50px 40px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .img-box {
          width: 100%;
          height: 80px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;

          img {
            width: 80px;
            height: 80px;

          }

          .img-number {
            font-family: Kavivanar, Kavivanar;
            font-weight: 400;
            font-size: 80px;
            color: #E8E8E8;
            line-height: 118px;
          }
        }


        .education-name {
          width: 100%;
          padding-top: 34px;
          box-sizing: border-box;
          border-top: 1px solid #E8E8E8;
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 16px;
        }

        .education-title {
          width: 100%;
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 30px;
        }
      }

      .education:hover {
        background: #4850D5;

        .education-name {
          color: #fff;
        }

        .education-title {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

  }
}


.choose-us-box {
  height: 740px;
  width: 100%;
  margin-bottom: 120px;

  .choose-us {
    width: 1320px;
    height: 100%;
    padding-top: 120px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .choose-us-left {
      width: 704px;
      height: 620px;
      margin-left: -58px;
      transition: all 0.8s;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .choose-us-left:hover {
      transform: rotateX(20deg);
    }

    .choose-us-right {
      width: 600px;
      height: 100%;
      padding-top: 26px;
      box-sizing: border-box;

      .choose-us-name {
        font-weight: bold;
        font-size: 54px;
        color: #333333;
        line-height: 64px;
        margin-bottom: 20px;
      }

      .choose-us-title {
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        line-height: 30px;
        margin-bottom: 90px;
      }

      .choose {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 120px;
        width: 598px;
        margin-bottom: 42px;

        .choose-box {
          width: 267px;
          height: 120px;

          .choose-img-box {
            width: 267px;
            height: 30px;
            display: flex;
            margin-bottom: 18px;

            img {
              width: 30px;
              height: 30px;
              margin-right: 14px;
            }

            .choose-img-title {
              font-weight: bold;
              font-size: 20px;
              color: #333333;
              line-height: 30px;
            }
          }

          .choose-name {
            font-weight: 400;
            font-size: 18px;
            color: #999999;
            line-height: 30px;
          }
        }
      }
    }
  }
}

.nuestros-box {
  width: 100%;
  height: 1100px;
  background: url(../assets/card1.png) center center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 300px 800px 300px 200px;
  font-size: 18px;

  .nuestros-boxmax {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 50px;
  }

  .nuestros-box-itemleftheader {
    display: flex;
    justify-content: left;
    margin-bottom: 40px;

    .nuestros-box-itemleftheaderleft {
      img {


        width: 140px;
        margin-right: 40px;
      }
    }

    .nuestros-box-itemleftheaderright {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 30px;

      img {
        margin-top: 30px;
        width: 200px;
        cursor: pointer;
      }
    }
  }
}

.services-box {
  width: 100%;
  height: 758px;
  background: url(../assets/serviceBg.png) center center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;

  .services {
    height: 100%;
    width: 1320px;
    margin: 0 auto;
    box-sizing: border-box;

    .services-block {
      width: 100%;
      height: 150px;
    }

    .service-title {
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      line-height: 63px;
      text-align: center;
      margin-bottom: 76px;
    }

    .item-service-box {
      width: 100%;
      height: 280px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item-service {
        width: 314px;
        height: 280px;
        padding: 50px 30px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.08);
        border-radius: 20px;
        transition: all 0.8s;

        img {
          width: 86px;
          height: 80px;
          margin-bottom: 20px;
        }

        .item-service-title {
          font-weight: bold;
          font-size: 22px;
          color: #333333;
          line-height: 36px;
          text-align: left;
        }
      }

      .item-service:hover {
        transform: translateY(-30px);
      }
    }
  }
}

.contact-box {
  width: 100%;
  height: 905px;

  .contact {
    width: 1320px;
    height: 100%;
    margin: 0 auto;
    padding-top: 150px;
    box-sizing: border-box;

    .contact-title {
      width: 100%;
      font-weight: bold;
      font-size: 54px;
      color: #333333;
      line-height: 63px;
      text-align: center;
      margin-bottom: 72px;
    }

    .contact-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      .offer-box {
        width: 414px;
        height: 100%;

        .offer-img {
          width: 414px;
          height: 270px;
          overflow: hidden;
          margin-bottom: 35px;

          img {
            width: 414px;
            height: 270px;
            transition: all 0.8s;
          }

          img:hover {
            transform: scale(1.2);
          }
        }

        .offer-title {
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          line-height: 28px;
          text-align: left;
          margin-bottom: 20px;
        }

        .offer-name {
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          line-height: 30px;
        }
      }
    }
  }
}

.reelbuzz-footer {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  background: #191A20;

  .footer-content {
    width: 1240px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    ;

    .footer-company {
      width: 570px;
      height: 100%;
      padding-top: 108px;
      box-sizing: border-box;

      .company-title {
        font-weight: 900;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 23px;
      }

      .company-name {
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 28px;
      }
    }

    .footer-menu {
      width: 256px;
      height: 100%;
      padding-top: 97px;
      box-sizing: border-box;

      .menu-title {
        font-weight: 900;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 24px;
      }

      .menu-name {
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 28px;
        cursor: pointer;
      }
    }

    .footer-contact {
      width: 410px;
      height: 100%;
      padding-top: 97px;
      box-sizing: border-box;

      .contact-title {
        font-weight: 900;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 18px;
      }

      .contact-name-box {
        width: 410px;
        min-height: 132px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        padding: 10px 12px;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 28px;
      }
    }
  }


}
</style>
